import { render, staticRenderFns } from "./magicindex.vue?vue&type=template&id=08b25c5c&scoped=true&"
import script from "./magicindex.vue?vue&type=script&lang=js&"
export * from "./magicindex.vue?vue&type=script&lang=js&"
import style0 from "./magicindex.vue?vue&type=style&index=0&id=08b25c5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b25c5c",
  null
  
)

export default component.exports